export const koreanTranslation = {
  "createNewWallet": "새로운 지갑 생성",
  "generateFantomWalletText": "당신의 고유 Nexis Network 지갑을 생성합니다. 고유 퍼블릭 주소를 수령하시고접속권한과 복구 인증서를 생성하세요",
  "getStarted": "시작하기",
  "connectFantomNetwork": "팬텀 네트워크와 프라이빗키를",
  "sendRecieveFTM": "NZT 전송과 수령",
  "stakeFTM": "NZT 예치",
  "collectRewards": "당신의 보상 수집",
  "accessNow": "지금 접속하기",
  "welcomeFantomWallet": "Fantom지갑에 오신걸 환영합니다",
  "sendReceiveStakeFTM": "당신의 FTM의 전송,수령 그리고 예치",
  "address": "주소",
  "balance": "잔고",
  "createWallet": "지갑 생성하기",
  "createKeystoreFilePassword": "키스토어 파일과 비밀번호 생성",
  "SetNewPassword": "새로운 비밀번호 설정",
  "walletPasswordValidationText": "영문 대문자, 기호, 숫자를 각각 최소 1개씩 포함한 8자 이상의 비밀번호를 생성해주세요",
  "reEnterPassword": "비밀번호를 다시 입력해 주세요",
  "backupKeystoreFileText": "나는 키스토어 파일과 비밀번호를 안전한 장소에 백업해 두었습니다",
  "walletCreationT&C": "나는 지갑에 접속하기 위해 비밀번호와 키스토어 파일이 필요하다는 것을 인지하고 있습니다",
  "passwordDoesNotMatch": "입력된 비밀번호가 일치하지 않습니다",
  "downloadKeystoreFile": "키스토어 파일 다운받기",
  "yourMnemonicPhrase": "당신의 니모닉 문구",
  "backupMnemonics": "아래 문자를 종이에 적은뒤 안전한 장소에 보관 부탁드립니다",
  "viewPrivateKey": "당신의 프라이빗 키 보기",
  "wroteRecoveryKey": "저는 복구 키를 기입해놨습니다",
  "verification": " 검증",
  "mnemonicOrderPhrase": "검증을 위한 당신의 니모닉 문구를 올바른 순서대로 선택해 주세요",
  "back": "뒤로",
  "verify": "확인",
  "youAllSet": "모두 완료되었습니다",
  "successfullyCreatedWallet": "당신은 성공적으로 지갑을 생성하였습니다",
  "accessWallet": "지갑 접속하기",
  "dashboard": "대시보드",
  "send": "전송",
  "receive": "수령하기",
  "stake": "예치하기",
  "recentActivity": "최근 활동",
  "overview": "개요",
  "price": "가격",
  "marketCap": "시가총액",
  "deposit": "입금",
  "sendFTM": "NZT 전송",
  "amount": "수량",
  "enterAmount": "수량 입력",
  "toAddress": "보내는 주소",
  "enterAddress": "주소 입력",
  "memo": "메모",
  "memoOptional": "메모(추가사항)",
  "enterMemo": "메모입력",
  "entireBalance": "전체 잔고",
  "copiedClipboard": "클립보드에서 붙여넣기",
  "clearAll": "모두 지우기",
  "enterWalletPassword": "당신의 거래내역을 전송하기 위해 지갑 비밀번호를 입력해 주세요",
  "enterWalletPasswordCommon": "지갑 암호를 입력하세요",
  "enterPassword": "비밀번호를 입력해 주세요",
  "invalidPassword": " 비밀번호 불일치",
  "sending": "전송중...",
  "transactionSent!": "거래내역전송 성공",
  "receiveFTM": "NZT 수령",
  "copy": "복사",
  "download": "다운로드",
  "availableStake": "예치 가능",
  "currentlyStaking": "현재 예치",
  "claimedRewards": "보상 요청",
  "availableClaim": "요청 가능",
  "whatLikeToDo?": " 당신은 무엇을 하고 싶습니까?",
  "selectValidator": "검증자 선택",
  "validatorsList": "검증자 목록",
  "Validators": "검증자",
  "clickValidator": "추가정보를 위해 검증자를 선택해 주세요",
  "name": "이름",
  "poi": "중요도 증명",
  "validatingPower": "검증권",
  "uptime": "가동 시간",
  "totalStaked": "총예치",
  "spaceLeft": "남은양",
  "commission": "수수료",
  "select": "선택",
  "enterWalletPasswordStake": "예치를 위해 당신의 비밀번호를 입력해 주세요",
  "congratulations": "성공적으로",
  "ftmSuccessfullyStaked": "FTM이 예치되었습니다.",
  "unstake": "인출",
  'ok': '인출',
  "stakeWithdrawalDays": "예치된 토큰의 인출은 7일이 소요됩니다",
  "maybeLater": "향후 지원",
  "enterWalletPasswordUnstake": "인출을 위해 당신의 지갑 비밀번호를 입력해 주세요",
  "prepareWithdrawalSuccessful": "인출준비 완료!",
  "ftmAvaliableDaysMsg": "당신의 1.05FTM은 6일 23시간 이후에 이용 가능합니다",
  "somethingWentWrong": "오류가 발생하였습니다.",
  "pleaseTryAgain": " 다시 시도해주세요",
  "Recipient": "받으신 분",
  "date": "일시",
  "canTransferMax":"최대치로 전송 가능합니다",

  "yourPrivateKey":"연결하세요",
  "incorrectMnemonicPhrase":"니모닉 문구가 일치하지 않습니다. 다시 시도해주세요",
  "transactionHash":"트랜잭션 해시",
  "invalidAmount":"수량이 올바르지 않습니다",
  "insufficentFundsTransfer":"전송할 잔액이 부족합니다",
  "enterValidFTMAddress":"유효한 NZT 주소를 입력하세요",
  "notEnoughFTM":"FTM이 충분하지 않습니다. 보다 적은 수량을 입력해주세요",
  "invalidStakeAmount":"스테이크할 수량이 올바르지 않습니다",
  "canStakeMax":"스테이크 가능한 최대 수량",
  "poiFull":"중요성 증명",
  "nodeFull":"현재 노드가 가득 찼습니다",
  "diffNode":"다른 노드를 선택해주세요",
  "restoreWallet":"지갑 복구하기",
  "pleaseEnterPassword":"암호를 입력해주세요",
  "pleaseUploadKeystore":"키스토어 파일을 업로드해주세요",
  "amountToStake":"스테이크한 수량",
  "summary":"요약",
  "validatorNode":"검증자 노드",
  "withdrawalSuccessful":"출금 완료",
  "wllaet":"이제 토큰을 지갑에서 확인 가능합니다",
  "enterWalletPasswordModal":"언스테이크 하기 위해 지갑 암호를 입력해주세요",
  "FTMAvail":"FTM을 출금 가능합니다!",
  "daysAnd":"일 그리고",
  "FTMAreAvailable":"FTM을 사용 가능합니다",
  "withdrawToWallet":"지갑으로 바로 출금하기",
  "mnemonicPhrase":"니모닉 문구",
  "privateKey":"프라이빗 키",
  "uploadKeystoreFile":"키스토어 파일 업로드",
  "keystoreSucessfullyLoaded":"키스토어 파일을 성공적으로 불러왔습니다",
  "enterYourWalletPassword":"지갑 암호를 입력하세요",
  "enterMnemonic":"12자 혹은 24자의 니모닉 문구를 한 칸씩 띄워서 모두 소문자로 입력해주세요",
  "invalidRecoveryPhrase":"복구 문구가 올바르지 않습니다",
  "typePrivateKey":"프라이빗 키를 입력하세요",
  "unlockWallet":"지갑 잠금 해제",
  "enterPrivateValidation":"0x로 시작하는 유효한 66 비트의 영숫자 개인키를 입력해주세요",
  'hours': '시간',
  'your': '너의',
  "logoutMsg":"로그아웃 하시겠습니까?",
  "logoutDesc": '로그아웃 시 지갑이 로컬 저장소로부터 지워집니다. 다시 엑세스하기 위해서 프라이빗 키 또는 니모닉 문구를 필요로 합니다.',
  "reverseAction": '다음으로 진행 시 취소가 불가능합니다.',
  "sent":"전송되었습니다",
  "fee": '手续费',
  "cancel": '취소',
  "logout": '로그아웃',
  'rewards': '보상',
  "unstaking": '언스테이킹...',
  "withdraw": '출금',
  "withdrawing": '출금중...',
  "invalidKeystoreTitle": "유효하지 않은 키스토어 파일 혹은 암호입니다.",
  "keystore": "키스토어",
  "max":"최대",
  "staking":"스테이킹...",
  'minStakeReq': '스테이크를 하기 위해 최소 1 FTM이 필요합니다',
  "howMuchFTM":"FTM을 얼마나 스테이킹하시겠습니까",
  "accountAlreadyExist":"해당 주소를 보유한 계정이 이미 존재합니다",
  "minimumAmountAlert": "인출하기 위해 잔액이 최소",
  "minimumAmountAlert1": "이상 필요합니다.",
  "minimumUnstakeAlert": "이상 필요합니다.",
  "browser": '브라우저',
  "Jan": "1 월",
  "Feb": "2 월",
  "Mar": "3 월",
  "Apr": "4 월",
  "May": "5 월",
  "Jun": "6 월",
  "Jul": "7 월",
  "Aug": "8 월",
  "Sept": "9 월",
  "Sep": "9 월",
  "Oct": "10 월",
  "Nov": "11 월",
  "Dec": "12 월",
  "th":"일",

}